import type { Locale } from "./types";
import { localizeDigits } from "./digits";

const dict = {
  en: {
    home: "Home",
    about: "About Us",
    subsidiaries: "Our Subsidiaries",
    contact: "Contact Us",
    overview: "Company Overview",
    story: "Our Story",
    mission: "Mission, Vision & Values",
    leadership: "Our Leadership",
    governance: "Corporate Governance",
    whoWeAre: "Who We Are",
    pillars: "Our Strategy Pillars",
    visitSite: "Visit website",
    learnMore: "Learn more",
    sendMessage: "Send message",
    name: "Full name",
    email: "Email",
    phone: "Phone",
    subject: "Subject",
    message: "Message",
    sent: "Thank you. Your message has been sent.",
    sendError: "Something went wrong. Please try again.",
    required: "Please complete the required fields.",
    followUs: "Follow us",
    quickLinks: "Quick links",
    business: "Business",
    businesses: "Our businesses",
    businessesTitle: "Three businesses. One holding.",
    businessesIntro: "Neweast Arabia Holding brings together spare parts, Isuzu and NEXTAR under one Saudi platform — each with its own brand, customers and website.",
    viewBusinesses: "Explore the group",
    storyIntro: "From a trading house in 1992 to a Saudi holding platform — the chapters that shaped Neweast Arabia Holding.",
    aboutLegacy: "About Our Legacy",
    partnerTitle: "Let’s shape tomorrow together",
    partnerBody: "Partner with Neweast Arabia Holding — whether you are exploring collaboration, investment, or a conversation with one of our businesses.",
    quoteLabel: "Leadership",
    getInTouch: "Get in touch",
    visitOffice: "Our office",
    callUs: "Call us",
    emailUs: "Email us",
    sendAMessage: "Send a message",
    formHint: "A partnership, a visit, or a question for one of our businesses — write to us and we will get back to you.",
    whatsapp: "WhatsApp",
    language: "العربية",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    readBio: "Profile",
    values: "Our Values",
    pillarsTitle: "What guides the group.",
    leadershipIntro: "The people who steer Neweast Arabia Holding. Names, titles and portraits can be updated from the dashboard.",
    notFoundTitle: "This page is not here.",
    notFoundBody: "The link may be outdated. Return home, or visit one of our businesses.",
    tryAgain: "Try again",
    unableToLoad: "Unable to load this page",
    governanceIntro: "A quiet framework for how the holding is overseen — board direction, ethical conduct, and a clear path to every business we represent.",
    governanceClose: "These principles sit behind the group. They can be refined from the dashboard as Neweast Arabia Holding grows.",
    governanceEyebrow: "Accountability",
    backHome: "Back to home",
    loading: "Loading…",
    moments: "In motion",
    momentsTitle: "A look across the group.",
    hoverExplore: "Hover or tap a frame",
  },
  ar: {
    home: "الرئيسية",
    about: "من نحن",
    subsidiaries: "شركاتنا التابعة",
    contact: "اتصل بنا",
    overview: "نبذة عن الشركة",
    story: "قصتنا",
    mission: "الرسالة والرؤية والقيم",
    leadership: "قيادتنا",
    governance: "الحوكمة المؤسسية",
    whoWeAre: "من نحن",
    pillars: "ركائز استراتيجيتنا",
    visitSite: "زيارة الموقع",
    learnMore: "اعرف المزيد",
    sendMessage: "إرسال الرسالة",
    name: "الاسم الكامل",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    subject: "الموضوع",
    message: "الرسالة",
    sent: "شكراً لك. تم إرسال رسالتك.",
    sendError: "حدث خطأ. يرجى المحاولة مرة أخرى.",
    required: "يرجى تعبئة الحقول المطلوبة.",
    followUs: "تابعنا",
    quickLinks: "روابط سريعة",
    business: "الأعمال",
    businesses: "أعمالنا",
    businessesTitle: "ثلاث شركات. قابضة واحدة.",
    businessesIntro: "تجمع نيويست أرابيا القابضة أعمال قطع الغيار وإيسوزو ونكستار تحت منصة سعودية واحدة — لكل منها علامتها وعملاؤها وموقعها.",
    viewBusinesses: "استكشف المجموعة",
    storyIntro: "من بيت تجاري في 1992 إلى منصة قابضة في السعودية — المحطات التي صنعت نيويست أرابيا القابضة.",
    aboutLegacy: "إرثنا",
    partnerTitle: "لنصنع الغد معاً",
    partnerBody: "شاركنا في نيويست أرابيا القابضة — سواء كنت تبحث عن تعاون أو استثمار أو حوار مع إحدى شركاتنا.",
    quoteLabel: "القيادة",
    getInTouch: "تواصل معنا",
    visitOffice: "مكتبنا",
    callUs: "اتصل بنا",
    emailUs: "راسلنا",
    sendAMessage: "أرسل رسالة",
    formHint: "شراكة، زيارة، أو سؤال لإحدى شركاتنا — اكتب لنا وسنعود إليك.",
    whatsapp: "واتساب",
    language: "English",
    openMenu: "فتح القائمة",
    closeMenu: "إغلاق القائمة",
    readBio: "الملف",
    values: "قيمنا",
    pillarsTitle: "ما يوجّه المجموعة.",
    leadershipIntro: "القيادات التي تُسيّر نيويست أرابيا القابضة. يمكن تحديث الأسماء والمناصب والصور من لوحة التحكم.",
    notFoundTitle: "هذه الصفحة غير موجودة.",
    notFoundBody: "قد يكون الرابط قديماً. عد إلى الرئيسية، أو زر إحدى شركاتنا.",
    tryAgain: "حاول مرة أخرى",
    unableToLoad: "تعذّر تحميل هذه الصفحة",
    governanceIntro: "إطار هادئ لكيفية الإشراف على الشركة القابضة — توجيه المجلس، والسلوك الأخلاقي، ومسار واضح إلى كل عمل نمثله.",
    governanceClose: "تقف هذه المبادئ خلف المجموعة، ويمكن تطويرها من لوحة التحكم مع نمو نيويست أرابيا القابضة.",
    governanceEyebrow: "المساءلة",
    backHome: "العودة للرئيسية",
    loading: "جاري التحميل…",
    moments: "لقطات",
    momentsTitle: "إطلالة على المجموعة.",
    hoverExplore: "مرّر أو اضغط على لقطة",
  },
} as const;

export type UiKey = keyof typeof dict.en;

export function t(locale: Locale, key: UiKey) {
  return localizeDigits(dict[locale][key], locale);
}

export function otherLocale(locale: Locale): Locale {
  return locale === "ar" ? "en" : "ar";
}

export function switchLocalePath(pathname: string, next: Locale) {
  const parts = pathname.split("/");
  if (parts[1] === "en" || parts[1] === "ar") {
    parts[1] = next;
    return parts.join("/") || `/${next}`;
  }
  return `/${next}`;
}
